module.exports = __webpack_public_path__ + "img/pic.bc513fb0.jpg";